<template>
    <component :is="component" :paginationData="paginationData" :memberData="memberData" v-if="component"/>
</template>

<script>
    export default {
        name: "MemberListLink",
        mixins: [],
        components: {
        },
        inject: [],
        provide() {
            return{

            }
        },
        props: {
            listLayout: {},
            memberData: {default: () => []},
            paginationData: {
                type: Object,
                default: {
                    total: 0,
                    page: 0,
                    size: 0,
                }
            },
        },
        data() {
            return{
                component: null,
            }
        },
        beforeRouterEnter() {},
        created() {
        },
        mounted() {
            this.paginationData.total = this.memberData.length
            this.listLoader();
        },
        beforeDestroy() {
        },
        destroyed() {},
        computed: {
            loader() {
                if (!this.listLayout) {
                    return null
                }
                return () => import(`@/template/member/list/${this.listLayout}`)
            },
        },
        methods:{
            listLoader() {
                this.loader()
                    .then(() => {
                        this.component = () => this.loader()
                    })
                    .catch(() => {
                        this.component = () => import('@/template/member/list/MemberListCuratorLayout')
                    })
            }
        },
        watch: {

        },
    }
</script>

<style scoped>

</style>
